// @flow

export const GRID_ITEM_WIDTH = 236;
export const AMP_GRID_ITEM_WIDTH = 170;

export const DESKTOP_GUTTER_WIDTH = 24;

export const MIN_COLUMNS = 2;

export const BOT_PIN_GRID_NUMBER = 125;
export const NON_BOT_PIN_GRID_NUMBER = 16;
export const GRID_GUTTER_WIDTH = 14;

export const SSR_PIN_GRID_NUMBER = 16;
export const getMaxColumns = (pinCount?: number) => pinCount || SSR_PIN_GRID_NUMBER;

export const MAX_PIN_IMAGE_HEIGHT = 900;

export const IMAGE_ONLY_PIN_SPACING_DESKTOP = 12;
export const GRID_ITEM_SPACING_DESKTOP = 24;

export const getGridItemGutter = (isImageOnlyPin?: boolean = false) =>
  isImageOnlyPin ? IMAGE_ONLY_PIN_SPACING_DESKTOP : GRID_ITEM_SPACING_DESKTOP;

/* Function to add CSS based on the number of columns that are visible.
 * of columns
 *
 * columnsQuery(<width>, 3, 5, <content>) to target desktop layouts with 3-5 columns
 * Lowerbound and upperbound are both required.
 */
export const columnsQuery = (
  pinImageWidth: number,
  numColumnsBegin: number,
  numColumnsEnd: number,
  content: string,
) => {
  const columnWidth = pinImageWidth + GRID_GUTTER_WIDTH;
  const minWidth = numColumnsBegin * columnWidth;
  const maxWidth = (numColumnsEnd + 1) * columnWidth - 1;
  const styles = `
@media (min-width: ${minWidth}px) and (max-width: ${maxWidth}px) {
  ${content}
}
`;
  return styles;
};
